import Opportunity from "../models/Opportunity";
import User from "../models/User";
import TalentTeam from "../models/TalentTeam";


const fetchOpportunityForTalent = async({queryKey, signal}) => {
    const oppId = queryKey[1] || {}
    return Opportunity.fetchForTalent(oppId, {signal})
}
const fetchJobBoardForTalent = async({queryKey, signal}) => {
    const params = queryKey[1] || {};

    return User.fetchJobsForTalent(params, {signal})
}

const fetchCoverLettersForTalent = async({queryKey, signal}) => {
    const params = queryKey[1] || {};
    return User.fetchCoverLettersForTalent({signal}, params)
}
const fetchJobBoardDetails = async ({queryKey, signal}) => {
    const jobId = queryKey[1];

    return User.fetchJobDetailsForTalent(jobId, {signal})
};

const fetchAllTeamsForTalent = ({queryKey, signal}) => {
    const status = queryKey[1] || {};

    return TalentTeam.fetchAllTeamsForTalent({status},{signal})
}

const fetchTalentNotificationsInfinite = ({queryKey, signal, pageParam = 1}) => {
    const params = queryKey[1] || {};

    return User.fetchTalentNotifications({ ...params, page: pageParam }, {signal})
}
const fetchTalentNotification = ({queryKey, signal}) => {
    // const { messageId, ...params } = queryKey[1] || {};
    const messageId = queryKey[1] || {};

    return User.fetchTalentNotification(messageId)
}

const fetchLatestVideoInterviewForTalent = async ({queryKey, signal}) => {
    const LatestVideoInterviewRequest = TB.request(
        TB.api_endpoint(`/api/talent/video-interviews`)
    )

    let response = await LatestVideoInterviewRequest.get({signal}).catch(console.warn);

    if (!response || !TB.has(response, 'success.data.steps')) {
        throw new Error('Something went wrong')
    }

    await TB.wait(60000)
    return response.success.data.steps;
}
const searchAllTalentForMemberInvite = async({queryKey, signal}) => {

    const {team, search, talent_discipline_id} = queryKey[1]

    return  team.searchAllTalentForMemberInvite({search, talent_discipline_id}, {signal})
}

const searchTagsExpertise = async ({queryKey, signal}) => {
    const {search} = queryKey[1];

    const SearchRequest = TB.request(
        TB.api_endpoint(`/api/tags/expertise/search`), {search}
    )

    let response = await SearchRequest.get({signal}).catch(console.warn);

    if (!response || !TB.has(response, 'success.data')) {
        throw new Error('Something went wrong')
    }

    // let {
    //     industries = [],
    //     skills = [],
    //     disciplines = [],
    // } = response.success.data || {}
    return response.success.data;
}
const searchBrands = async({queryKey, signal}) => {

    const queryParams = queryKey[1] || {}

    let requestOptions = {signal}
    const searchRequest = TB.request(
        TB.api_endpoint(` /api/brands/search`), queryParams
    );

    let response = await searchRequest.get(requestOptions).catch(console.warn)

    if(!response?.success?.data?.brands) {
        throw new Error("Something went wrong")
    }
    return response?.success?.data?.brands
}


export {
    fetchOpportunityForTalent,
    fetchJobBoardForTalent,
    fetchCoverLettersForTalent,
    fetchJobBoardDetails,
    fetchAllTeamsForTalent,
    fetchTalentNotificationsInfinite,
    fetchTalentNotification,
    searchAllTalentForMemberInvite,
    fetchLatestVideoInterviewForTalent,
    searchBrands,
    searchTagsExpertise
}